module.exports = __webpack_public_path__ + "img/bg_onepack_dfod.585d33ed.png";